var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',_vm._b({attrs:{"items":_vm.items || _vm.choices,"multiple":"","filled":"","chips":"","small-chips":"","deletable-chips":"","disable-lookup":""},on:{"change":_vm.changeHandler,"input":_vm.updateHandler}},'v-combobox',_vm.commonProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }